<app-info title="components.please-be-patient.title">
  <p translate="components.please-be-patient.subtitle"></p>
</app-info>
